export default __webpack_public_path__ + "static/media/claudia-luchetti.2a529333.png";